import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { PassengersReportService } from '../../services/passengers-report.service';
import { CommonService } from '../../services/common.service';
import { DriverService } from '../../services/driver.service';
import swal from 'sweetalert2';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import * as AWS from 'aws-sdk/global';
import * as S3 from 'aws-sdk/clients/s3';

@Component({
  selector: 'app-driver',
  templateUrl: './driver.component.html',
  styleUrls: ['./driver.component.css']
})
export class DriverComponent implements OnInit {
  plates: any = [];
  user_account: any;
  imeiVei: any = {};
  driverById: any= {};
  FOLDER = 'passengerControl/';
  accessKey = 'AKIAJBSEKUWJ6JUFUTIA';
  secretKey = '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';
  bucketName = 'upload';
  imgName= '';
  driverImg: any = null;
  isSubmitted_1: any = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private passengersReportService: PassengersReportService,
    private commonService: CommonService,
    private driverService: DriverService,
    ) { }

  ngOnInit() {
    this.getPlates();
    this.getDriver();
  }

  getDriver(): void {
    this.route.paramMap.switchMap((params: ParamMap) => this.driverService.getDriver(params.get('idDriver')))
      .subscribe(response => {
        console.log('response component : ', response)
        if (response.length > 0) {
          this.driverById.Identification = response[0].identification;
          this.driverById.Name = response[0].name;
          this.driverById.Address = response[0].address;
          this.driverById.Vehicle = response[0].vehicle;
          this.driverById.PhoneNumber = response[0].phone;
          this.driverById.User_account = this.user_account;
          this.driverById.Id = response[0].id;
          this.driverById.Image = response[0].image;
          this.driverImg = this.driverById.Image;
          this.driverById.Rfid = response[0].rfid;
        }
      });
  }

  getPlates(): void {
    this.passengersReportService.getPlates(this.commonService.getUserName()).then(response => {
      this.plates = response;
      this.user_account = this.plates[0].user_account;
      this.imeiVei   = this.plates.user_account
      console.log('this.commonService.getUserName() ; ', this.commonService.getUserName())
      // fecha = Date.now();
      console.log('this plates', this.plates);
      console.log('this user_account', this.plates[0].user_account);
      console.log('this user_account', this.user_account);
    });
  }

  saveDriver(): void {
    console.log('this.commonService.getUserName() ; ', this.commonService.getUserName())
    let that = this
    this.driverById.User_account = this.commonService.getUserName();
    this.driverService.saveDriver(this.driverById)
      .then(obj => {
        const response = JSON.parse(obj.toString());
        console.log('conductor.component.crearActualizarConductor.response: ', response);
        if (response) {
          console.log('response : ', response)
          this.router.navigate(['/home/drivers']);
          if (response.status === 'EXITO') {
            swal({
              title: response.message,
              text: '',
              type: 'success',
              showCancelButton: false,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#ff5370',
              confirmButtonText: 'Volver',
              // cancelButtonText: 'No'
            }).catch(swal.noop);
          } else {
            swal({
              title: response.message,
              text: '',
              type: 'error',
              showCancelButton: false,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#ff5370',
              confirmButtonText: 'Volver',
              // cancelButtonText: 'No'
            }).catch(swal.noop);
          }
        }
      });
  }

  fileToUpload: File = null;

  handleFileInput(files: FileList) {
    let that = this
    this.fileToUpload = files.item(0);
    // this.driverById.Image = this.fileToUpload.name
    // console.log('this.fileToUpload : ', this.fileToUpload.name);
    console.log()
    if (this.driverById.Image === 'assets/images/social/driver.jpg') {
      this.fileToUpload = files.item(0);
      this.imgName=this.fileToUpload.name;
      let that = this;
      const bucket = new S3(
        {
          accessKeyId: this.accessKey,
          secretAccessKey: this.secretKey,
          region: 'us-west-2'
        }
      );
      const params = {
        Bucket: this.bucketName,
        Key: this.FOLDER+this.fileToUpload.name,
        Body: this.fileToUpload
      };

      bucket.upload(params, function (err, data) {
        if (err) {
          console.log('There was an error uploading your file: ', err);
          return false;
        }
        console.log('Successfully uploaded file.', data);
        that.driverById.Image = 'https://upload.s3-us-west-2.amazonaws.com/passengerControl/' + that.imgName;
        that.driverImg = 'https://upload.s3-us-west-2.amazonaws.com/passengerControl/' + that.imgName;
        // console.log("imagen conductor:"+that.conductorImg);
        return true;
      });
    }else {
      var url = this.driverById.Image;
      var fileName = url.replace(/^.*[\\\/]/, '');
      this.fileToUpload = files.item(0);
      this.imgName = this.fileToUpload.name;
      let that = this;
      const params = {
        Bucket: this.bucketName,
        Key: this.FOLDER + fileName
      };
      const bucket = new S3(
        {
          accessKeyId: this.accessKey,
          secretAccessKey: this.secretKey,
          region: 'us-west-2'
        }
      );
      const params1 = {
        Bucket: this.bucketName,
        Key: this.FOLDER + this.fileToUpload.name,
        Body: this.fileToUpload
      };

      bucket.deleteObject(params, function (err, data) {
        if (err) {
          console.log('There was an error deleting your file: ', err.message);
          return false;
        }

        console.log('Successfully deleted file.');
        return true;

      });
      bucket.upload(params1, function (err, data) {
        if (err) {
          console.log('There was an error uploading your file: ', err);
          return false;
        }
        console.log('Successfully uploaded file.', data);
        that.driverById.Image = 'https://upload.s3-us-west-2.amazonaws.com/passengerControl/' + that.imgName;
        that.driverImg = 'https://upload.s3-us-west-2.amazonaws.com/passengerControl/' + that.imgName;
        //console.log("imagen conductor 2:"+that.conductorImg);|
        //console.log("imagen conductor 2:"+ that.conductor.urlImageDriver);
        return true;
      });
    }
  }
}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/components/driver/driver.component.ts